module.exports = __webpack_public_path__ + "img/reloj-de-pared.7b6836a8.svg";